import { initClient } from '@ts-rest/core';
import { mijnKsyosContract } from '../../../common/contracts/contract';

export const mijnKsyosClient = initClient(mijnKsyosContract, {
    baseUrl: window.location.origin,
});
